export default "__VITE_ASSET__CUXGp5ap__"